import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import SearchField from 'components/atoms/SearchField'
import SubmitButton from 'components/atoms/buttons/SubmitButton'
import CheckboxInput from 'components/molecules/CheckboxInput'

const styles = theme => ({
  root: { minWidth: 700 },
  body: {
    height: 250,
    overflowY: 'scroll',
    margin: `${theme.spacing(3)
    }px 0`,
    padding: `0 ${theme.spacing(3)}px`,
    borderTop: `1px solid ${theme.palette.background.medium} `,
    borderBottom: `1px solid ${theme.palette.background.medium} `,
  },
  header: {
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px 0 0`
  },
  footer: {
    height: 50,
  },
})

const AssignTrapsPopover = ({
  groups,
  classes,
  onGroupSelect,
  selectedGroup,
  onSearchChange,
  onConfirmClick,
}) => (
  <div className={classes.root}>
    <Typography variant="h1">Assign to group</Typography>
    <Grid
      container
      justify="space-between"
      alignItems="center"
      className={classes.header}>
      <SearchField onChange={onSearchChange} width={300} />
    </Grid>
    <section className={classes.body}>
      {groups && !!Object.keys(groups).length && (
        Object.keys(groups).map((groupId) => {
          const group = groups[groupId]
          const isActive = !!selectedGroup && selectedGroup.uuid === group.uuid

          return (
            <CheckboxInput
              key={group.uuid}
              value={group.uuid}
              onClick={onGroupSelect}
              active={isActive}
              text={group.name}
            />
          )
        })
      )}
    </section>
    <Grid
      container
      justify="flex-end"
      alignItems="center"
      className={classes.footer}>
      <SubmitButton
        size="medium"
        loading={false}
        color="primary"
        variant="primary"
        onClick={onConfirmClick}
        disabled={!selectedGroup}>
          Assign
      </SubmitButton>
    </Grid>
  </div>
) 

AssignTrapsPopover.propTypes = {
  groups: PropTypes.object,
  classes: PropTypes.object,
  onClearClick: PropTypes.func,
  onGroupSelect: PropTypes.func,
  onSearchChange: PropTypes.func,
  onConfirmClick: PropTypes.func,
  selectedGroup: PropTypes.object,
}

export default withStyles(styles)(AssignTrapsPopover)



// WEBPACK FOOTER //
// ./src/components/organisms/AssignTrapsPopover/AssignTrapsPopover.js